// extracted by mini-css-extract-plugin
export default {"wrapper":"RefferelProgramAndMothelyInvitationVsCompletedTask_wrapper__MHYeH"};